"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShieldIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var Shield = function Shield(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.38 5.68a.51.51 0 0 0-.71 0L12 9.33 8.33 5.68a.51.51 0 0 0-.71 0 .5.5 0 0 0 0 .71L11.29 10l-3.67 3.69a.5.5 0 0 0 0 .62.5.5 0 0 0 .7.08L12 10.74l3.67 3.66a.56.56 0 0 0 .35.15.58.58 0 0 0 .36-.15.51.51 0 0 0 0-.71L12.71 10l3.67-3.64a.5.5 0 0 0 0-.68Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.5 0h-17A1.5 1.5 0 0 0 2 1.5v6.26a18.23 18.23 0 0 0 9.77 16.18.47.47 0 0 0 .46 0A18.23 18.23 0 0 0 22 7.76V1.5A1.5 1.5 0 0 0 20.5 0Zm.5 7.79A17.25 17.25 0 0 1 12 23 17.25 17.25 0 0 1 3 7.79V1.53A.5.5 0 0 1 3.5 1h17a.5.5 0 0 1 .5.5Z"
  }));
};
Shield.defaultProps = {
  'data-name': "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const ShieldIcon = exports.ShieldIcon = (0, _createIconComponent.default)(Shield, 'ShieldIcon');